// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"378414d5","1744":"14c19478","2947":"11b01132","3107":"8eda9465","5405":"14c19478","5655":"506b322f","6093":"378414d5","6237":"88866f66","7564":"fa0b7864","8316":"fa0b7864","8674":"8eda9465","8688":"c558803c"}[chunkId] + ".chunk.css";
};